<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-card elevation="0" outlined>
                    <v-card-title class="text-h6">Restrict Access to: </v-card-title>
                    <v-card-subtitle><i>Last updated at {{ updateddatetime }}</i></v-card-subtitle>
                    <v-card-text v-if="callingdata">
                        <v-container style="height: 60px;">
                            <v-row class="fill-height" align-content="center" justify="center">
                                <v-col cols="6">
                                    <v-progress-linear
                                        color="#977EBE"
                                        indeterminate
                                        rounded
                                        height="4"
                                    ></v-progress-linear>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-text v-else>
                        <v-radio-group v-model="maintenancegroup" row hide-details dense>
                            <v-radio
                                label="None" value="none"
                            ></v-radio>
                            <v-radio
                                label="Applicant Only" value="applicant"
                            ></v-radio>
                            <v-radio
                                label="All (Admin and Applicant)" value="all"
                            ></v-radio>
                        </v-radio-group>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog" width="600" persistent>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="#977EBE" dark v-bind="attrs" v-on="on" small>Update Maintenance Mode</v-btn>
                            </template>
                            <v-card>
                                <v-toolbar elevation="0" color="#977EBE" dark>
                                    <v-toolbar-title>Update Maintenance Mode?</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click="dialog = false">
                                        <v-icon>mdi-close-thick</v-icon>
                                    </v-btn>
                                </v-toolbar><br />
                                <v-card-text v-if="maintenancegroup == 'none'">
                                    This update will turn Maintenance Mode off and will grant access to all authorized users. Continue?
                                </v-card-text>
                                <v-card-text v-if="maintenancegroup == 'applicant'">
                                    This update will turn Maintenance Mode on and will prevent <b>applicants</b> from accessing to the system. Continue?
                                </v-card-text>
                                <v-card-text v-if="maintenancegroup == 'all'">
                                    This update will turn Maintenance Mode on and will prevent <b>all authorized users &#40;admin and applicants&#41;</b> from accessing to the system. Continue?
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="#977EBE" text @click="setMaintenanceMode" :loading="updateloading">
                                        DO IT!
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>
                </v-card>
                <v-divider></v-divider>
                <v-card elevation="0" outlined>
                    <v-card-title>Notifications for Active and Expired Postings Log</v-card-title>
                    <v-card-text>
                        <ViewNotificationsLog />
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import ViewNotificationsLog from "./ViewNotificationsLog.vue"
export default {
    components: {
        ViewNotificationsLog
    },
    data () {
      return {
        host: location.hostname.toString(),
        snackbar: false,
        snackbarcolor: "",
        text: "",
        timeout: 3500,
        callingdata: true,
        dialog: false,
        maintenancegroup: "none",
        updateddatetime: "",
        updateloading: false
      }
    },
    methods: {
        getMaintenanceMode(){
            const that = this;
            that.callingdata = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getmaintenance';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (result) {
                    if(!result.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+result.message, "#EF6C00"); //orange
                    }else {
                        if(JSON.stringify(result.data) != "{}"){
                            var date = new Date();
                            if(result["data"].hasOwnProperty("updatedTimestamp")){
                                date = new Date(parseFloat(result["data"]["updatedTimestamp"]));
                            }else {
                                date = new Date(parseFloat(result["data"]["createdTimestamp"]));
                            }

                            that.updateddatetime = date.toDateString()+", "+String(date.getHours()).padStart(2, '0')+":"+String(date.getMinutes()).padStart(2, '0')+":"+String(date.getSeconds()).padStart(2, '0');
                            that.maintenancegroup = result.data.config.group;

                        }

                        that.callingdata = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.callingdata = false;
                })
            //End of API calling
        },
        setMaintenanceMode(){
            const that = this;
            that.updateloading = true;
            
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

            const formData = new FormData();

            formData.append("mode", "setmaintenance");
            formData.append("data", JSON.stringify({group : that.maintenancegroup}));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Set Maintenance Mode successfully!", "#388E3C"); //green
                        that.dialog = false;
                    }

                    that.updateloading = false;
                })
                .catch(function(err){
                    that.updateloading = false;
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getMaintenanceMode();
    }
}
</script>